/* eslint-disable sonarjs/media-has-caption */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { useTranslation } from 'react-i18next';

const GalleryView = ({ media, setSelected }) => {
  const { t } = useTranslation();

  if (!media || media.length === 0) {
    return (
      <div>
        <p>{t('reports.no_media')}</p>
      </div>
    );
  }

  const isImage = (link) => link.toLowerCase().match(/\.(jpeg|jpg|gif|png)/);
  const isVideo = (link) => link.toLowerCase().match(/\.(mp4|ogg|mov)/);
  const thumbnail = (link) => link;

  // const showModal = (link) => {
  //   document.body.classList.add('modal-open');
  //   setSelected(link);
  // };

  return (
    <div className="image-gallery">
      {media.map((mediaLink) => (
        <div key="mediaLink" className="report-image cursor-pointer inline-block">
          {isImage(mediaLink) && (
            <button type="button" onClick={() => setSelected(mediaLink)}>
              <img style={{ height: '150px', width: '150px' }} src={thumbnail(mediaLink)} alt="" />
            </button>
          )}
          {isVideo(mediaLink) && (
            <button type="button" onClick={() => setSelected(mediaLink)}>
              <video style={{ height: '150px', width: '150px' }}>
                <source src={mediaLink} />
              </video>
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default GalleryView;
